<template>
  <v-app>
    <toolbar v-if="$route.name != 'Login'"></toolbar>
    <v-content>
      <router-view/>
    </v-content>
    <snack-bar></snack-bar>
    <v-footer v-if="$route.name == 'Login'">
      <v-spacer></v-spacer>
      Version 2.5.0
      <v-spacer></v-spacer>
    </v-footer>
  </v-app>
</template>

<script>
import Toolbar from './layouts/Toolbar'
import SnackBar from './components/SnackBar'
export default {
  name: 'App',
  components : {
    Toolbar,
    SnackBar
  },
  data: () => ({
    //
  }),
  mounted () {
    this.applyColors()
    this.applyLang()
    this.refreshData()
  },
  methods: {
    applyColors() {
      if ( this.$store.state.game.data !== null) {
        this.$vuetify.theme.themes.light.primary = this.$store.state.game.data.gameVersion.style.colors.primary
        this.$vuetify.theme.themes.light.secondary = this.$store.state.game.data.gameVersion.style.colors.secondary
      }
    },
    applyLang() {
      if ( this.$store.state.game.data !== null) {
        this.$i18n.locale = this.$store.state.game.data.params.lang
        this.$vuetify.lang.current = this.$store.state.game.data.params.lang
      }
    },
    refreshData() {
      this.$store.commit('user/SET_loading', false)
      if ( this.$store.state.user.auth !== null && this.$store.state.game.data !== null) {
        this.$store.dispatch('game/getOne', this.$store.state.game.data._id)
        this.$store.dispatch('company/getOne', this.$store.state.company.data._id)
      }
    }
  }
};
</script>
<style >
html { overflow-y: auto !important; }
.v-btn__content{
  flex: auto;
}
.v-btn {
  white-space: normal;
}
.custom-divider {
border-top: 2px solid black !important;
} 
.v-text-field--outlined .v-text-field__slot label {
  background-color: white !important;
}
</style>